import React, { useState } from "react"
import { useNavigate } from "react-router"
import { useSelector, useDispatch } from "react-redux"
import { Button, Form, Input, Select, Tag } from "antd"
import { LockOutlined } from "@ant-design/icons"

// Components
import showSecondarySidebar from "../../../../../../layout/MainLayout/helpers/showSecondarySidebar"
import Page from "../../../../../../components/Decoration/Page"
import { ModalResetPassword } from "./resetPassword"

// Services Library
import { REDUX } from "../../../../../../services/util"

// Redux Actions
import * as REDUX_ACTIONS from '../../../../../../services/redux/actions'

// Style
import styles from './index.module.css'

const UserEditForm = ({
    data = {}
}) => {

    // const title = data?.title || 'Create'

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [ form ] = Form.useForm()

    const [ openResetPwd, setOpenResetPwd ] = useState(false)
    const [ svhcgids, setSvhcgids ] = useState(data?.vhcgids || []) 

    const user = useSelector(REDUX.reduxStoreWrapper('user'))
    const userRoles = useSelector(REDUX.reduxStoreWrapper('userRoles.byID'))
    const vehicleGroups = useSelector(REDUX.reduxStoreWrapper('vehicleGroups'))
    const vehicles = useSelector(REDUX.reduxStoreWrapper('vehicles.staticsByID'))
    const loading = useSelector(REDUX.reduxStoreWrapper('style.loading.user'))

    // const vg = useSelector(REDUX.reduxStoreWrapper('vehicleGroups'))
    // const vehicleIDs = vg.relationByUID[data.uid] || []

    // const userListOptions = Object.values(userList).map(ul => ({
    //     label: ul.name,
    //     value: ul.uid
    // }))
    const userRoleOptions = Object.values(userRoles)
        ?.filter(ur => ur.hierarchy >= userRoles[data.uroleid].hierarchy)
        ?.map(urole => ({
            label: urole.roleName,
            value: urole.uroleid
        }))

    // const vehicleOptions = vehicleIDs?.map(v => ({
    //     label: vg?.byID?.[v]?.name || '-',
    //     value: v
    // }))

    const vehicleGroupOptions = 
    // [
    //     ...(
        (vehicleGroups?.relationByUID?.[user?.uid] || [])
        ?.map(vg => ({
            label: vehicleGroups.byID[vg]?.name,
            value: vehicleGroups.byID[vg]?.vhcgid
        }))
        // ?.filter(vg => vg.label !== 'ALL') || []
    //     ,
    //     ...(vehicleGroups?.relationByUID?.[data?.uid] || [])
    //     ?.map(vg => ({
    //         label: vehicleGroups.byID[vg]?.name,
    //         value: vehicleGroups.byID[vg]?.vhcgid
    //     })) || []
    // ]


    const onFinish = (e) => {

        const items = {
            userInfo: {
                ...e,
                contact: `${e.contactPrefix}-${e.contact}`,
                uid: data.uid,
            },
            preHierCode: data.hierCode || '',
            vhcgids: user.uid === data.uid ? data.vhcgids : [ ...e.vhcgids || [], `vhcg#${data.uid}` ]
        }

        delete items.userInfo.contactPrefix
        delete items.userInfo.vhcgids

        dispatch(REDUX_ACTIONS.v3_userHierarchy.user_profile_update_request(items, () => {
            navigate(`/management/user`)
        }))

    }

    const ContactPrefix = (
        <Form.Item name={'contactPrefix'} noStyle>
            <Select options={[ { value: '+60', label: '+60' } ]} />
        </Form.Item>
    )

    const vehicleArrs = svhcgids?.map(vhcgid => vehicleGroups.byID[vhcgid]?.vehicles)?.flatMap(v => v)
    const noDuplicatedVehicleArrs = [ ...new Set(vehicleArrs) ]?.filter(v => vehicles[v]?.status)

    const VGSet = new Set(vehicleGroupOptions.map(v => v.value))

    return (
        <div className="page-container">
            <Page title={`Edit User`}>
                <ModalResetPassword 
                    data={{ name: data?.name || '', uid: data?.uid || '', email: data?.email || '' }} 
                    open={openResetPwd}
                    onCancel={() => setOpenResetPwd(false)}
                />
                <Form 
                    style={{ width: '50vw', minWidth: '60em', margin: '5em auto'}}
                    labelCol={{ span: 5 }}
                    form={form}
                    onFinish={onFinish}
                    initialValues={{
                        ...data,
                        imei: data?.dvid?.split('#')[1],
                        contactPrefix: '+60',
                        contact: data?.contact?.split('-')[1],
                        vhcgids: data.vhcgids?.filter(vhcgid => VGSet.has(vhcgid)) 
                    }}
                >
                    <Form.Item
                        label="User Name"
                        name="name"
                        rules={[
                            {
                                required: true,
                                message: 'Please input user name!',
                            },
                        ]}
                        >
                            <Input size="large" />
                        </Form.Item>
                        <Form.Item
                            label="Email Address"
                            name="email"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input vehicle email address!',
                                },
                            ]}
                        >
                            <Input size="large "/>
                        </Form.Item>
                        <Form.Item
                            label="User Role"
                            name="uroleid"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input user role!',
                                },
                            ]}
                        >
                            <Select options={userRoleOptions} size="large "/>
                        </Form.Item>
                        <Button icon={<LockOutlined />} className={`${styles['button']} ${styles['cancel']}`} style={{ margin: '0 0 2em 12.5em'}} onClick={() => setOpenResetPwd(true)}>Reset Password</Button>
                        <Form.Item
                            label="Contact Number"
                            name="contact"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input user contact!',
                                },
                                // {
                                //     pattern: /^(?:\+60|60|0)(?:1[0-46-9][0-9]{7,8}|[3-9][0-9]{7,8})$/,
                                //     message: 'Please input phone number'
    
                                // }
                            ]}
                            >
                                <Input addonBefore={ContactPrefix} size="large" />
                            </Form.Item>
                        <Form.Item
                            label="Office Address"
                            name="address"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input address!',
                                },
                            ]}
                            >
                                <Input size="large" />
                            </Form.Item>
                            {
                                (user.uid !== data.uid)
                                &&
                                <>
                                    <Form.Item
                                        label="Vehicle Group"
                                        name="vhcgids"
                                        // rules={[
                                        //     {
                                        //         required: true,
                                        //         message: 'Please input vehicle group!',
                                        //     },
                                        // ]}
                                    >
                                        <Select 
                                            mode='multiple' size="large" 
                                            options={vehicleGroupOptions} 
                                            onChange={e => setSvhcgids(e)} 
                                            tagRender={({ value, label, closable, onClose }) => 
                                                <Tag 
                                                    // color={vehicleGroups.byID[value]?.color !== '#FFFFFF' ? vehicleGroups[value]?.color : 'default'}
                                                    color={vehicleGroups.byID[value]?.color}
                                                    closable={closable}
                                                    onClose={onClose}                                  
                                                >
                                                    {label}
                                                </Tag>}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label="Vehicle Selected"
                                    >
                                        {
                                            noDuplicatedVehicleArrs?.length && noDuplicatedVehicleArrs.map((vhc, i) => <h4 key={i}>{i + 1}. {vehicles[vhc]?.plate}</h4>) || ''
                                        }
                                    </Form.Item>
                                </>
                            }

                        <div className={styles['button-container']}>
                            <Button className={`${styles['button']} ${styles['cancel']}`} onClick={() => navigate(-1)}>Cancel</Button>
                            <Button className={`${styles['button']} ${styles['add']}`} loading={loading} htmlType="submit">{'Save'}</Button>
                        </div>
                </Form>
            </Page>
        </div>
    )
}

const MemoizedUserEditForm = React.memo(UserEditForm);

export default showSecondarySidebar(false)(MemoizedUserEditForm);